var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBluedownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2114)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1_2114)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8546 21.8892C19.8546 22.4414 19.4069 22.8892 18.8546 22.8892L1.06014 22.8892C0.507856 22.8892 0.0601425 22.4414 0.0601424 21.8892L0.0601423 20.0001C0.0601422 19.4478 0.507858 19.0001 1.06014 19.0001L18.8546 19.0001C19.4069 19.0001 19.8546 19.4478 19.8546 20.0001L19.8546 21.8892ZM1.79496 10.242C1.15851 9.61402 1.60321 8.53022 2.49734 8.53022L4.71571 8.53022C5.26799 8.53022 5.71571 8.08251 5.71571 7.53022L5.71571 1.1594C5.71571 0.60712 6.16342 0.159404 6.71571 0.159404L13.199 0.159403C13.7513 0.159403 14.199 0.607119 14.199 1.1594L14.1991 7.53022C14.1991 8.0825 14.6468 8.53022 15.1991 8.53022L17.4174 8.53022C18.3115 8.53022 18.7562 9.61402 18.1198 10.242L10.6597 17.6031C10.2703 17.9874 9.64442 17.9874 9.25501 17.6031L1.79496 10.242Z",
    fill: "#329DFF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1_2114",
    x: 0.0601807,
    y: 0.15918,
    width: 19.7944,
    height: 23.73,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_2114"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2114"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 23,
    fill: "white",
    transform: "translate(20 23) rotate(180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluedownload);
export default __webpack_public_path__ + "static/media/bluedownload.7aeab9475c3b9dc011609f20cbf33402.svg";
export { ForwardRef as ReactComponent };